import React from "react";
// import heroimage from "../imgs/Typing.gif";
import Nav from "./navbar";
import { arrayOfProjects, createPorjectCard } from "./ProjectsArray";
import Footer from "./footer";
import "../styles.css";
import "../popup.css";
import "../try.css";
import Fade from "react-reveal/Fade";
import { MyProjmg } from "..//imgs//images";

export default function Projects() {
  function componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidMount();

  return (
    <>
      <Nav />
      <header className="cheap-flex">
        <div>
          <div className="cheap">
            Checkout <br /> <span className="cheap-text">My WORK.</span>
          </div>
        </div>
        <img className="project-hero-img" src={MyProjmg} alt="Project header" />{" "}
      </header>
      <a href="#my-projects">
        <div className="container-parent">
          {" "}
          <div class="container-down">
            <div class="chevron"></div>
            <div class="chevron"></div>
            <div class="chevron"></div>
            {/* <span class="text">Scroll down</span> */}
          </div>
        </div>{" "}
      </a>

      <h1
        id="my-projects"
        className="hero-heading  margt2rem blog-project-heading-big"
      >
        <span className="blog-head">My Projects</span>
      </h1>

      <div className="project-grid">
        <Fade bottom>{arrayOfProjects.map(createPorjectCard)}</Fade>
      </div>

      <Footer />
    </>
  );
}
